<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				ref="table"
				height="tableHeight"
			>
				<el-table-column
					label-class-name="column-index"
					label="序号"
					type="index"
					width="50"
					align="center">
				</el-table-column>
				<el-table-column
					prop="styleName"
					label="页面名称"
					align="center">
				</el-table-column>
				<el-table-column
					prop="shopattendway"
					label="适用门店"
					align="center">
					<template slot-scope="scope">
						{{scope.row.shopattendway === 0 ? '全部门店' : '部分门店'}}
					</template>
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="启用状态"
					align="center">
					<template slot-scope="scope">
						{{scope.row.disabledflag ? '停用' : '启用'}}
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="editHandleClick(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handlePageChange"
					:current-page="pagination.page"
					:page-sizes="[20,40, 60, 100]"
					:page-size="pagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		id: {
			type: String
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			}
		}
	},
	created () {
	},
	methods: {
		rowClick (row) {
			this.editHandleClick(row)
		},
		editHandleClick (row) {
			// window.sessionStorage.setItem('percentageId', value.planid)
			if (this.AuthorityList['16_0001_0001_00']) {
				this.$router.push({ path: '/main/pageSettingDetail', query: { id: row.id } })
			} else {
				this.$message.error('您没有页面装修权限,不可查看该页面！')
			}
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus">
.main-table {
	display flex
	flex: 1
	flex-direction: column
	width: 100%
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	overflow: hidden
	overflow-y: auto;
	.main-table-box {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		display flex
		flex-direction: column
		flex: 1
	}
	.pagination {
		width: 100%;
		position: fixed;
		bottom: 0;
	}
}
</style>
<style lang="stylus">

</style>
